import Marquee from "react-fast-marquee";
import { Leaf } from "lucide-react";

const ITEMS = ["Médecine chinoise", "Magnétisme", "Sophrologie", "Ventouses", "Ostéothérapie", "Réflexologie plantaire", "Breathwork", "Constellations familiales", "Massages du monde"];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="border-y border-olive-border/70 bg-beige-200/60 py-5 overflow-hidden">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-8 font-serif text-xl italic text-olive/80">
            {item}
            <Leaf className="w-4 h-4 text-olive-light/70" strokeWidth={1.5} />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
